import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GeneratePdfFosilService } from 'app/services/generate-pdf-fosil.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FunctionsService, HeaderFilters, HttpService, MenuBreadCrumb, MessageService, params, TableColumns, TableConfiguration } from 'brainloper-ui';
import { FuelHistoryDetailComponent } from './fuel-history-detail/fuel-history-detail.component';
import { FuelOrder } from 'app/models2/fuel/fuel-order';

@Component({
  selector: 'app-fuel-history',
  templateUrl: './fuel-history.component.html',
  styleUrls: ['./fuel-history.component.scss']
})
export class FuelHistoryComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Historicos combustible",
    current:true
  }]

  public urlTableFO: string = `${EndpointDictionary.HistoricalFuel.HISTORICAL_FUEL_TABLE}`
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`
  private urlComboEquipo : string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`

  public params: params[] = [ { id: 'equipmentId', value: '0' }, { id: 'active', value: '0' }]
  public data: FuelOrder
  public selected = new UntypedFormControl(0);

  public titleFO: string = screen.width > 360 ? 'Historial Combustible' : 'H.F'
  public recargarTablaFO = new EventEmitter<any>()
  public configurationFO: TableConfiguration = {
    edit: true,
    selectable: true,
    editPer: true,
    primaryKey: 'id',
    print: true,
    exportXslx:true,
    hideTitle:true,
    view:true
  }

  public columnasFO: TableColumns<FuelOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil'
      },
    },
    {
      ID: 'code',
      label: 'Código Equipo',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'requestsName',
      label: 'Solicita',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'place',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'fuelType',
      label: 'Tipo de Combustible',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'currentOdometer',
      label: 'odómetro/horómetro',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'totalPrice',
      label: 'Costo',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    }
  ]

  headerFilters: Array<HeaderFilters> = [
    {
      tN: "equipos",
      labelFilter:"Equipo",
      urlData: this.urlComboEquipo,
      visibleField:"code",
      primaryKey:"id",
      type:"select",
      value:""
    },
    {
      tN: "historico_combustible",
      visibleField:"fecha",
      type:"date",
      value:""
    },
    {
      tN: "historico_combustible",
      visibleField:"fecha",
      type:"dateRange",
      value:""
    }
  ]

  headerFileXlsm:Array<params> = [
    {id:"consecutive", value:"Número de Orden"},
    {id:"code", value:"Código del equipo"},
    {id:"fuelType", value:"Tipo combustible"},
    {id:"date", value:"Fecha"},
    {id:"gallons", value:"Galones"},
    {id:"totalPrice", value:"Precio total"},
    {id:"place", value:"Proveedor"},
    {id:"billNumber", value:"Nómero de factura"},
    {id:"salesOrder", value:"Orden de venta"},
    {id:"authorizeName", value:"Autorizó"},
    {id:"requestName", value:"Solicitó"},
  ]

  constructor(
    public dialog: MatDialog,
    private message: MessageService,
    private http: HttpService,
    private functionEter: FunctionsService,
    private generatePdf: GeneratePdfFosilService
  ) { }

  ngOnInit(): void {
  }


  async viewDetail($event: FuelOrder[]){
   try {
      let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${$event[0].id}`)
      if(res){
        this.data = res[0]
        this.data.date = this.functionEter.dateIso(res[0].date)

        this.selected.setValue(1)
      }

    } catch (error) {
      this.message.Error('Error', error)
    }
  }

  async editFO($event: FuelOrder[]){
    try {
       let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${$event[0].id}`)
     if(res){
       this.dialog.open(FuelHistoryDetailComponent,{
         width:'80%',
         height:'80%',
         data:res[0]
       }).afterClosed().subscribe(
         res=>{
           this.recargarTablaFO.emit()
         }
       )
     }
    } catch (error) {
      this.message.Error('Error', error)
    }
   }

  back($event) {
    switch ($event.index) {
      case 0:
        this.selected.setValue(0)
        break;
      case 1:
        this.selected.setValue(1)
        break;
      case 2:
        this.selected.setValue(2)
        break;
      default:
        break;
    }  //console.log($event)
  }

  async print($event: FuelOrder) {
    this.generatePdf.printTemplateFO($event[0].id)
  }

}
